import { filter } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import * as XLSX from 'xlsx';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';


@Component({
  selector: 'app-create-doa-approval',
  templateUrl: './create-doa-approval.component.html',
  styleUrls: ['./create-doa-approval.component.css']
})
export class CreateDoaApprovalComponent implements OnInit {
  isBright: boolean = true;
  isOpenDoctypeModel: boolean = true;
  selectedDocumentType: any = { docTypeId: 0, docTypeName: '', isCommentMandatory: false };

  docTypeList: any = [];
  documentType_MST: any;

  workItemFieldList: any = [];

  @ViewChild('documentTypeModal') documentTypeModal: ElementRef;
  modalReference: any;
  field_ids: any;



  //Grid Params

  ItemData_pending: any;
  lstData_pending = [];


  columnsToHide: any = ['DOA_DATA_ID', 'CREATED_BY', 'REQUEST_DOA_ID'];

  reportName_pending: string = 'Pending Requests'

  hyperlinkCols: any = ['action_icon_Approve', 'action_icon_Reject'];
  status: string;
  DOA_DATA_IDarray = [];

  //Comment section
  isCommentExpand: boolean = false;
  restrictedKeywords: any = [];
  transactionComment: string = "";
  wordsTotal: any = 1000;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {

    this.restrictedKeywords = this.commonService.getRestrictedKeywords()
  }

  ngOnInit(): void {
    this.getDocumentTypes();
  }

  checkRestrictedKeywords() {
    let foundedRestrictedKeyword = [];
    let input: any = this.transactionComment;
    this.restrictedKeywords.forEach(keyword => {
      if (input.includes(keyword.restrict)) {
        input = input.replaceAll(keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.transactionComment = input;
      this.commonService.showMessageBox('We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.', 'Warning');
    }
  }
  function(data) {

    this.wordsTotal = 1000 - data.length
  }

  async onChangeDoctype(docType: any) {
    this.isOpenDoctypeModel = false;
    this.selectedDocumentType = docType;

    this.getField_Mapping_Ids();

    this.modalReference.close();
  }

  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('action', 'manual creation');
   params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService
      .getData('document-types', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.documentType_MST = res.data;
              for (var i = 0; i < res.data.length; i++) {
                this.docTypeList.push({
                  docTypeId: res.data[i].document_type_id,
                  docTypeName: res.data[i].document_type_name,
                  isCommentMandatory: res.data[i].is_comment_mandatory_for_create_workitem
                });
              }
              this.showModal(this.documentTypeModal, 'sm');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }
  getField_Mapping_Ids() {

    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('doc_id', this.selectedDocumentType.docTypeId);
    this.dataService.getData('Field_Mapping_IDs_DOA', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != null && res.data.Table != null) {

            this.field_ids = res.data.Table[0].id

            this.getDOAdata_pending()

          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })



  }




  getDOAdata_pending() {
    // let user_id = this.commonService.getUserInfoFromLocalStorage('userId');
    let user_id = this.memorystore.getItem('userId');
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids,
      searchobj: {},
      searchflag: false
    };
    this.dataService.postData('getDOAdata_pending', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.ItemData_pending = res.data.Table.filter((e) => {
          return e.CREATED_BY != user_id;
        });
        this.ItemData_pending.forEach(e => {
          e["action_checkbox_button"] = false;

        })
        this.lstData_pending = this.ItemData_pending;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })

  }


  onGridCellClick(event: any) {
    var val = event.rowData.DOA_DATA_ID;

    if (event.rowData.action_checkbox_button == false) {
      this.DOA_DATA_IDarray.push(val)
    }
    else {

      const index = this.DOA_DATA_IDarray.indexOf(val);
      if (index > -1) { // only splice array when item is found
        this.DOA_DATA_IDarray.splice(index, 1); // 2nd parameter means remove one item only
      }

    }
    //this.DOA_request_update(val);
  }

  selectallClick(event: any) {

    if (event.value == "true") {
      this.DOA_DATA_IDarray = [];
      this.lstData_pending.forEach(e => {
        this.DOA_DATA_IDarray.push(e.DOA_DATA_ID)
      })
    }
    else {
      this.DOA_DATA_IDarray = [];
    }

  }

  submit_request(status) {
    if (this.DOA_DATA_IDarray.length == 0) {
      this.commonService.showMessageBox('Please select alteast one request', 'Alert');
      return;
    }

    this.status = status;
    if (this.status == "Rejected") {
      if (this.transactionComment == "") {
        this.commonService.showMessageBox('Comment is mandatory', 'Alert');
        return;
      }

    }
    this.DOA_request_update();

  }



  DOA_request_update() {

    let params = {
      project_id: Number(this.commonService.selectedProject),
      doc_id: Number(this.selectedDocumentType.docTypeId),
      Field_ids: this.field_ids,
      Status: this.status,
      DOA_id: this.DOA_DATA_IDarray.join(","),
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      comment: this.transactionComment
    };
    this.dataService.getData('DOA_request_update', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.transactionComment = "";
        this.DOA_DATA_IDarray = [];
        if (res.status == true) {
          var msg = "DOA " + this.status + " successfully."
          this.commonService.showMessageBox(msg, 'Success');
        }
        else {
          var msg = "Couldn't process the request" + res.error_message
          this.commonService.showMessageBox(msg, 'Error');
        }
        this.getDOAdata_pending();
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })
  }

}
